/* LabRemoteLogger.js */

"use strict";
const LogAdapter = require("../BaseLogger");

class LabRemoteLogAdapter extends LogAdapter {
    constructor(labUserSession) {
        super();
        this._logLine = 1;
        this._labUserSession = labUserSession;
    }
    /**
     * Method for the loggers to use to send back logging info to show up in Lab.
     */
    _remoteLog(continuation, lvl, msg, depth, logEventInfo) {
        if (this._labUserSession) {
            let lln = this._logLine++;

            let logData = {
                lln: lln, // Log Line Number
                time: Date.now(), // Current time.
                depth: depth, //Depth in the tasks of the logging.
                lvl: lvl, // Log Level "DEBUG", "INFO", etc.
                msg: msg, // Log message
            };

            let auxObj = logEventInfo.auxObj;
            if (auxObj) {
                logData.auxObj = auxObj;
            }

            let fileName = logEventInfo.fileName;
            if (fileName) {
                logData.fn = fileName;
            }

            let fileLineNum = logEventInfo.fileLineNum;
            if (fileLineNum || fileLineNum === 0) {
                logData.fnl = fileLineNum;
            }

            let time = logEventInfo.time;
            if (time) {
                logData.time = time;
            }

            //Translate the ending TASK specific logEventInfo data.
            if (lvl === "TASK") {
                if (logEventInfo.taskCompletionState) {
                    logData.taskCompletionState = logEventInfo.taskCompletionState;
                    logData.taskDuration = Date.now() - time;
                }
            }

            //TODO add Tag information.

            //console.log("logData: "+JSON.stringify(logData));

            //Send the log message back to show up in Lab.
            this._labUserSession.connection.sendMessage("log", {
                contId: continuation.getId(),
                logData: logData,
            });
        }
    }

    debug(continuation, msg, depth, logEventInfo) {
        super.debug(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "DEBUG", msg, depth, logEventInfo);
    }
    warning(continuation, msg, depth, logEventInfo) {
        super.warning(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "WARNING", msg, depth, logEventInfo);
    }
    info(continuation, msg, depth, logEventInfo) {
        super.info(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "INFO", msg, depth, logEventInfo);
    }
    checkPoint(continuation, msg, depth, logEventInfo) {
        super.checkPoint(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "CHECKPOINT", msg, depth, logEventInfo);
    }
    taskStart(continuation, msg, depth, logEventInfo) {
        super.taskStart(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "TASK", msg, depth, logEventInfo);
    }
    taskEnd(continuation, msg, depth, logEventInfo) {
        super.taskEnd(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "TASK", msg, depth, logEventInfo);
    }
    abort(continuation, msg, depth, logEventInfo) {
        super.abort(continuation, msg, depth, logEventInfo);
        this._remoteLog(continuation, "ABORT", msg, depth, logEventInfo);
    }
}
module.exports = LabRemoteLogAdapter;
